import script from "./ScopeImport.vue?vue&type=script&setup=true&lang=js"
export * from "./ScopeImport.vue?vue&type=script&setup=true&lang=js"

import "./ScopeImport.vue?vue&type=style&index=0&id=434630e0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-434630e0"]])

export default __exports__